/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Features_LearnInputs */

const en_gc_resources_features_learn = /** @type {(inputs: Gc_Resources_Features_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find your starting point`)
};

const zh_gc_resources_features_learn = /** @type {(inputs: Gc_Resources_Features_LearnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`从指南开始`)
};

/**
* | output |
* | --- |
* | "Find your starting point" |
*
* @param {Gc_Resources_Features_LearnInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_features_learn = /** @type {((inputs?: Gc_Resources_Features_LearnInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Features_LearnInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_features_learn(inputs)
	return zh_gc_resources_features_learn(inputs)
});
export { gc_resources_features_learn as "gc.resources.features.learn" }